// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3552":"6298760e","6640":"9cc03917"}[chunkId] + ".chunk.css";
};